import { SET_CURRENT_ARTICLE, SET_ARTICLES_LIST } from "../actions/types";

const initialState = {
  currentArticle: null,
  articles: [],
};

const articleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_ARTICLE:
      return { ...state, currentArticle: action.payload };
    case SET_ARTICLES_LIST:
      return { ...state, articles: action.payload };
    default:
      return state;
  }
};

export default articleReducer;
